export enum GENERAL_PAGE_TYPE {
  STANDARD = 'general_pages.StandardPage',
  LEGAL_DOCUMENT = 'general_pages.LegalDocumentPage',
  ARCHIVED_EDITORIAL = 'general_pages.ArchivedEditorialsPage',
}
